<template>
  <div class="section-row">
    <span class="section-row-header">
      {{ resources.pickADeliveryOptionLabel }}
      <a
        v-if="shouldShowPickADeliveryOption"
        @click="openModalOrFlyIn()"
        class="section-link hide-on-mobile"
        :title="resources.pickADeliveryOptionCTA"
      >
        {{ resources.pickADeliveryOptionCTA }}
      </a>
    </span>

    <div v-if="resources.unavailableMessage" class="inline-alert error">
      <span v-html="resources.unavailableMessage"></span>
    </div>

    <div class="vertical-tile-list" v-if="!loadingState">
      <delivery-option-tile
        v-for="option in selectedDeliveryMethod.options.slice(0, 3)"
        :key="option.id"
        :option="option"
        :methodId="selectedDeliveryMethod.id"
      />

      <a
        v-if="shouldShowPickADeliveryOption"
        @click="openModalOrFlyIn()"
        class="section-link hide-on-tablet"
        title="Select different delivery option"
      >
        {{ resources.pickADeliveryOptionCTA }}
      </a>
    </div>
    <loader-animation :number="3" v-if="loadingState"/>
  </div>
</template>
<script src="./delivery-option-tile-list.js"/>
